import * as React from 'react'
import { CssBaseline } from '@material-ui/core'
import { QueryCache, ReactQueryCacheProvider } from 'react-query'
import BabyUIThemeProvider from 'baby-ui/foundation/BabyUIThemeProvider'
import AppBar from 'baby-ui/compounds/AppBar'
import Footer from 'baby-ui/compounds/Footer'
import { createRootStore, DMEStoreProvider } from '../../store'
import { LayoutContextProvider, useLayout } from './LayoutContext'
import { DMETheme } from '../../styles'
import { FOOTER_NAV } from './constants'
import { DMEAppProps } from '../../DMEApp'
import InsuranceVerificationOverlay from '../InsuranceVerificationOverlay/InsuranceVerificationOverlay'
import AnnouncementBannerWidget from '../AnnouncementBannerWidget/AnnouncementBannerWidget'

export interface LayoutProps extends Pick<DMEAppProps, 'settings'> {
  children: React.ReactNode
}

const queryCache = new QueryCache()

export default function Layout({ settings, children }: LayoutProps) {
  return (
    <LayoutContainer settings={settings}>
      <AppBar />
      {children}
      <Footer navGroups={FOOTER_NAV} />
    </LayoutContainer>
  )
}

export const LayoutContainer: React.FC<LayoutProps> = ({
  settings,
  children,
}) => {
  const theme = new DMETheme()
  const rootStore = createRootStore()

  return (
    <LayoutContextProvider value={settings}>
      <DMEStoreProvider value={rootStore}>
        <ReactQueryCacheProvider queryCache={queryCache}>
          <BabyUIThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </BabyUIThemeProvider>
        </ReactQueryCacheProvider>
      </DMEStoreProvider>
    </LayoutContextProvider>
  )
}

export const LayoutPresenter: React.FC = ({ children }) => {
  const layout = useLayout()

  return (
    <>
      <AppBar />
      {layout?.isFreeGiftEnabled && <AnnouncementBannerWidget />}
      <InsuranceVerificationOverlay />
      {children}
      <Footer navGroups={FOOTER_NAV} />
    </>
  )
}
